module.exports = __webpack_public_path__ + "img/car.2ddd25a.svg";